import * as bootstrap from "bootstrap"

window.addEventListener("turbo:frame-load", function(event) {
  const modalContainerId= 'modal_container';
  if (event.target.id==modalContainerId) {
    // console.log("Loading modal window");
    const modalElm= event.target.firstChild;
    const modalOptions={};

    if (modalElm) {
      // console.log(`Activating modal window ${modalElm.id}`);
      let modal = bootstrap.Modal.getOrCreateInstance(modalElm, modalOptions);
      if (modal) {
        // Remove any lost backdrop due to modal overlapping
        const bdElm= document.querySelector('aside.popups ~ .modal-backdrop.show');
        if (bdElm) bdElm.remove();

        modalElm.addEventListener('shown.bs.modal', event => {
          // Set focus on first form field when modal is shown
          const firstInputElm= modalElm.querySelector('form *[autofocus]');
          if (firstInputElm) firstInputElm.focus();
        })

        modal.show();
      }
    }
  }
});
